import { useContext } from 'react';
import { FormControllerContext } from '../Context.js';

/* ----------------------- useFormController ----------------------- */
function useFormController() {
  var formController = useContext(FormControllerContext);
  return formController;
}

export { useFormController };
